import { Flow_Action__Input } from '~/graphql/types';
import { DeleteContactTagAction } from './types.flow';
import { ActionTreeNode } from '~/scenes/Automation/Flows/components/FlowActionTrees/types.flow';
import { ActionInputDefaults } from '~/scenes/Automation/Flows/Actions/types.flow';

import { asPureStringPrimitiveParameterValueInput } from '~/scenes/Automation/Flows/Actions/Base/FlowParameter/ParameterValue/String/asStringPrimitiveParameterValueInput';

export default (
  action: DeleteContactTagAction,
  treeNode: ActionTreeNode,
  inputActionDefaults: ActionInputDefaults,
): Flow_Action__Input => {
  const { id, name } = action;
  const { accountId, flowBlueprintId } = inputActionDefaults;
  const { parentId } = treeNode;

  if (parentId == null)
    throw new Error(`Parentless DeleteContactTagAction found! ID: ${id}`);

  return {
    Contact: {
      DeleteTag: {
        id,
        accountId,
        flowBlueprintId,
        parentId,
        name: asPureStringPrimitiveParameterValueInput(name),
      },
    },
  };
};
